import httpClient, { IRequest, IResponse } from '../../../apiService/httpClient';
import { ICrestRopeSpecificationsRequest } from '../IApiRequest';
import {
    IAnchorTypesResponse,
    ICrestRopeSpecificationsResponse,
    ILanguagesResponse,
    IMacro1AnchorTypeResponse,
    IMacro1MeshTypeResponse,
    IMeshTypeResponse,
    IRopeCoreTypesResponse,
    IRopesResponse,
    IRopeSteelsResponse,
} from '../IApiResponse';

const BeMaccaferriProductsProvider = () => {
    let _baseURL = process.env.REACT_APP_BE_BASE_URL as string;

    const _createRequest = <D>(_pathname: string, _queryString?: string, _data?: D): IRequest => {
        return {
            url: _queryString ? _pathname + '?' + _queryString : _pathname,
            baseURL: _baseURL,
            data: _data,
        };
    };

    const getMeshTypes = async (country: string, unit?: string, lang?: string): Promise<IResponse<IMeshTypeResponse[]>> =>
        httpClient.getAsync(_createRequest('v2/macro2/products/mesh-types?unitsType=' + unit + '&country=' + country + '&lang=' + lang));
    const getRopesTypes = async (country: string, unit?: string, lang?: string): Promise<IResponse<IRopesResponse[]>> =>
        httpClient.getAsync(_createRequest('v2/macro2/products/ropes-types?unitsType=' + unit + '&country=' + country + '&lang=' + lang));
    const getRopeSteels = async (unit?: string, lang?: string): Promise<IResponse<IRopeSteelsResponse[]>> =>
        httpClient.getAsync(_createRequest('v1/macro2/products/rope-steels?unitsType=' + unit + '&lang=' + lang));
    const getRopeCores = async (lang?: string): Promise<IResponse<IRopeCoreTypesResponse[]>> => httpClient.getAsync(_createRequest('v1/macro2/products/rope-core-types?lang=' + lang));
    const getAnchorTypes = async (country: string, unit?: string, lang?: string): Promise<IResponse<IAnchorTypesResponse[]>> =>
        httpClient.getAsync(_createRequest('v2/macro2/products/anchor-types?unitsType=' + unit + '&country=' + country + '&lang=' + lang));
    const getCrestRopeSpecification = async (requestData: ICrestRopeSpecificationsRequest, unit?: string, lang?: string): Promise<IResponse<ICrestRopeSpecificationsResponse>> =>
        httpClient.getAsync(
            _createRequest(
                'v1/macro2/products/crest-rope-specification',
                `unitsType=${unit}&ropeId=${requestData.ropeId}&ropeSteelId=${requestData.ropeSteelId}&ropeCoreTypeId=${requestData.ropeCoreTypeId}&lang=${lang}`,
            ),
        );

    const getMacro1MeshTypes = async (country: string, unit?: string, lang?: string): Promise<IResponse<IMacro1MeshTypeResponse[]>> =>
        httpClient.getAsync(_createRequest('v2/macro1/products/mesh-types?unitsType=' + unit + '&country=' + country + '&lang=' + lang));
    const getMacro1AnchorTypes = async (country: string, unit?: string): Promise<IResponse<IMacro1AnchorTypeResponse[]>> =>
        httpClient.getAsync(_createRequest('v2/macro1/products/anchor-types?unitsType=' + unit + '&country=' + country));

    const getLanguages = async (): Promise<IResponse<ILanguagesResponse>> => httpClient.getAsync(_createRequest('v1/multilanguage/languages'));

    return {
        getMeshTypes,
        getRopesTypes,
        getRopeSteels,
        getRopeCores,
        getAnchorTypes,
        getCrestRopeSpecification,
        getMacro1MeshTypes,
        getMacro1AnchorTypes,
        getLanguages,
    };
};
export default BeMaccaferriProductsProvider();
